export const environment = {
  production: true,
  apiBaseUrl: 'https://api.doctainium.com/api/',
  baseUrl: 'https://api.doctainium.com/',
  webUrl: 'https://www.doctainium.com/',
  session: 'pdf_pub_live_D9DIRKr2MCnBpMSJg0qnr9jeos8UTRS3nLkDfIowzYG',
  //apiBaseUrl: 'https://publicportal.inceptiontech.com/service/api/',
  //baseUrl: 'https://publicportal.inceptiontech.com/service/',
  //webUrl: 'https://publicportal.inceptiontech.com/',
  successMessageLifeTime: 5000,
  warningMessageLifeTime: 5000,
  errorMessageLifeTime: 10000,
  // In Minutes
  sessionTimeOut: 60,
  messageLifeSpan: 5000
};
